import {backendUrl} from '@/assets/js/config'
import axios from '@/assets/plugins/axios'

export default {
  // 获取权限列表
  getMoudleAuthList (orgId){
    return axios.get(`${backendUrl}/authorization/list-auth-item-codes?orgId=${orgId}&productCode=gccs_base-paas`)
  },
  // 根据组织id获取当前是企业租户还是个人租户
  getTenantInfo (tenantId){
    return axios.get(`${backendUrl}/geip/getTenantInfo/${tenantId}?includeExtendInfo=false`)
  }
}
